import Box from '@mui/material/Box';

import { Job } from '~hooks/useJob/models';
import { Load, LoadCycle } from '~hooks/useLoad/models';
import { Ticket } from '~hooks/useTickets/models';

import { columns, gridTemplateColumns } from './loads-table-columns';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

export interface LoadsTableProps {
  cycles: LoadCycle[];
  job: Job;
  loads: Load[];
  onTableRowClick: (loadId: string, ticket?: Ticket) => void;
  tickets: Ticket[];
}

export default function LoadsTable({
  cycles,
  job,
  loads,
  onTableRowClick,
  tickets,
}: LoadsTableProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoRows: 'auto',
        gridTemplateColumns,
        gridTemplateRows: '35px',
      }}
    >
      {columns.map((column) => (
        <TableHeader key={column.key} title={column.title} sx={column.sx} />
      ))}

      {loads.map((load, index) => (
        <TableRow
          key={load.id}
          cycles={cycles}
          job={job}
          load={load}
          number={index + 1}
          onClick={onTableRowClick}
          tickets={tickets}
        />
      ))}
    </Box>
  );
}
